import { render, staticRenderFns } from "./ItemRadio.vue?vue&type=template&id=c8c65f9a&scoped=true&"
import script from "./ItemRadio.vue?vue&type=script&lang=js&"
export * from "./ItemRadio.vue?vue&type=script&lang=js&"
import style0 from "./ItemRadio.vue?vue&type=style&index=0&id=c8c65f9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c65f9a",
  null
  
)

export default component.exports